import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import RatingItem from './KpiSelfRatingItem';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import {KPI_SELF_RATING_LIST} from '../../../models/kpiModels';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class KpiSelfRatingPanel extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            kpi: this.props.kpi,
            activeKpi:{
              value: undefined
            },
            label: appHelper.getLocaleString("self_rating_prompt"),

        };
        this.setActiveKpi = this.setActiveKpi.bind(this);
    }

    componentDidMount() {


    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                label: appHelper.getLocaleString("self_rating_prompt"),
            });
        }
    }

    setActiveKpi(kpi){
        this.setState({activeKpi: Object.assign(kpi)});
        this.props.onComplete(kpi);
    }

    render() {
        return (
            <div className="text-center">
                <div><strong>{this.state.label}</strong></div>
                <div className="kpi-self-rating-list" >
                    {KPI_SELF_RATING_LIST.map(kpi =>
                        <RatingItem key={kpi.value} kpi={kpi} onClickFunc={this.setActiveKpi} activeKpi={this.state.activeKpi}/>
                    )}
                </div>
            </div>
        );
    }
}

KpiSelfRatingPanel.propTypes = {
    kpi: PropTypes.object.isRequired,
    bite_id: PropTypes.number.isRequired,
    onComplete: PropTypes.func.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

KpiSelfRatingPanel.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(KpiSelfRatingPanel);



/** WEBPACK FOOTER **
 ** ./src/components/objects/kpi/KpiSelfRatingPanel.js
 **/